export function filterSelectableData(data, selectableType) {
    return data.filter(item => item.type === selectableType);
}
